module.exports = __webpack_public_path__ + "hu.e4b82010101ab330ca3e.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/hu.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/hu.svg
// module chunks = styles